import React, { useState } from 'react';
import Form from '@anonymizePro/components/form';
import Logo from '@anonymizePro/components/icons/logo';
import SubmitForm from '@anonymizePro/components/form/submit-form';

function Index() {
    const [step, setStep] = useState(0);
    return (
        <div className="flex w-full items-center justify-center bg-gradient-to-r from-blue-300 to-blue-700 py-14 md:py-[96px]">
            <div className="mx-5 flex flex-col items-center rounded-[8px] bg-white px-14 pb-20 md:px-[93px] lg:rounded-[16px] lg:px-[192px]">
                <Logo className="my-12" />
                {step === 0 && <Form setStep={setStep} />}
                {step === 1 && <SubmitForm />}
            </div>
        </div>
    );
}

export default Index;
